import { symbolToken } from '@servicetitan/react-ioc';

export const USE_LOGGER_TOKEN = symbolToken<string>('USE_LOGGER_TOKEN', false);

export type Logger = Console;

export const logger: Logger = console;
